export { categoryLinkHTML as default } from "discourse/helpers/category-link";
